export default __webpack_public_path__ + "static/media/soehne-web-leicht.38995d68.woff2";